import { action } from '@ember/object';
import Component from '@glimmer/component';
import BvTextField from 'volta/components/bv-text-field';
import isPresent from 'volta/helpers/is-present';
import autofocus from 'volta/modifiers/autofocus';

export interface IArgs {
  value?: string | number;
  class?: string;
  disabled?: boolean;
  autoFocus: boolean;
  fullWidth?: boolean;
  placeholder?: string;
  onInput?: (event?: InputEvent) => void;
  onClear?: (event: MouseEvent) => void;
}

interface SingleTriggerSignature {
  Args: IArgs;
  Element: HTMLElement;
}

export default class SingleTrigger extends Component<SingleTriggerSignature> {
  @action
  onChange(_value: string | number, _id: string, event?: InputEvent) {
    this.args.onInput?.(event);
  }

  @action
  onClear(_id: string, event: MouseEvent) {
    this.args.onClear?.(event);
  }

  <template>
    <BvTextField
      @onChange={{this.onChange}}
      @value={{@value}}
      @class={{@class}}
      @clearButton={{isPresent @onClear}}
      @disabled={{@disabled}}
      @onClearButtonClick={{if @onClear this.onClear}}
      @fullWidth={{@fullWidth}}
      @placeholder={{@placeholder}}
      {{autofocus @autoFocus}}
      ...attributes
    />
  </template>
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'BvSelectCreate::SingleTrigger': typeof SingleTrigger;
    'bv-select-create/single-trigger': typeof SingleTrigger;
  }
}
